export default __webpack_public_path__ + "static/media/heroimage.517845c4.jpg";